import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionsWhiten = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
              What is professional teeth whitening?
              </Accordion.Header>
              <Accordion.Body>
              Professional teeth whitening is a safe and effective way to lighten the natural colour of your teeth, helping to lift stains and restore a brighter, fresher-looking smile.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
              How does teeth whitening work?
              </Accordion.Header>
              <Accordion.Body>
              We use specially formulated whitening gels that gently break down stains within the enamel, lightening your teeth safely under the care of our dental team.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
              Is teeth whitening safe?
              </Accordion.Header>
              <Accordion.Body>
              Yes, when carried out by qualified dental professionals like us at Regent Dental, teeth whitening is completely safe and your smile is in expert hands.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
              Will teeth whitening make my teeth sensitive?
              </Accordion.Header>
              <Accordion.Body>
              Some people may experience a little temporary sensitivity, but this usually settles very quickly. We’ll guide you through how to minimise any discomfort.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
              How do I get started with teeth whitening?
              </Accordion.Header>
              <Accordion.Body>
              Simply book a consultation with us! We’ll check your oral health, discuss your goals, and create a whitening plan that’s perfect for you.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        <Col lg={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
              How long does teeth whitening take?
              </Accordion.Header>
              <Accordion.Body>
              With our at-home whitening kits, you’ll usually see noticeable results within 10–14 days. We’ll design a treatment plan that fits around your lifestyle.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="5"
              onClick={() => handleToggle("5")}
            >
              <Accordion.Header as="h3" className="red-header">
              How white will my teeth get?
              </Accordion.Header>
              <Accordion.Body>
              Results vary from person to person, but most patients achieve a beautifully natural and noticeably brighter smile. We’ll discuss what you can expect during your consultation.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="6"
              onClick={() => handleToggle("6")}
            >
              <Accordion.Header as="h3" className="red-header">
              How long will my whitening results last?
              </Accordion.Header>
              <Accordion.Body>
              With good care and occasional top-ups, your results can last for several years. Avoiding staining foods, drinks, and smoking will help maintain your brighter smile.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
              Can I whiten crowns, veneers, or fillings?
              </Accordion.Header>
              <Accordion.Body>
              Teeth whitening treatments only work on natural teeth. If you have crowns, veneers, or fillings, we’ll chat with you about the best ways to achieve an even-looking smile.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
              What’s the difference between professional and over-the-counter whitening?
              </Accordion.Header>
              <Accordion.Body>
              Professional whitening is much safer, more effective, and tailored to your teeth. Over-the-counter products are weaker and can sometimes damage your teeth or gums if used incorrectly.
              </Accordion.Body>
            </Accordion.Item>
            
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionsWhiten;
